export const eesRequirementsCountries = [
  { value: 'BEL', name: 'Belgium' },
  { value: 'FRA', name: 'France' },
  { value: 'NLD', name: 'Netherlands' },
  { value: 'GBR', name: 'United Kingdom' },
  { value: 'USA', name: 'United States of America' },
  { value: 'AFG', name: 'Afghanistan' },
  { value: 'ALB', name: 'Albania' },
  { value: 'DZA', name: 'Algeria' },
  { value: 'AND', name: 'Andorra' },
  { value: 'AGO', name: 'Angola' },
  { value: 'ATG', name: 'Antigua and Barbuda' },
  { value: 'ARG', name: 'Argentina' },
  { value: 'ARM', name: 'Armenia' },
  { value: 'AUS', name: 'Australia' },
  { value: 'AUT', name: 'Austria' },
  { value: 'AZE', name: 'Azerbaijan' },
  { value: 'BHS', name: 'Bahamas' },
  { value: 'BHR', name: 'Bahrain' },
  { value: 'BGD', name: 'Bangladesh' },
  { value: 'BRB', name: 'Barbados' },
  { value: 'BLR', name: 'Belarus' },
  { value: 'BLZ', name: 'Belize' },
  { value: 'BEN', name: 'Benin' },
  { value: 'BTN', name: 'Bhutan' },
  { value: 'BOL', name: 'Bolivia, Plurinational State of' },
  { value: 'BIH', name: 'Bosnia and Herzegovina' },
  { value: 'BWA', name: 'Botswana' },
  { value: 'BRA', name: 'Brazil' },
  { value: 'BRN', name: 'Brunei Darussalam' },
  { value: 'BGR', name: 'Bulgaria' },
  { value: 'BFA', name: 'Burkina Faso' },
  { value: 'BDI', name: 'Burundi' },
  { value: 'CPV', name: 'Cabo Verde' },
  { value: 'KHM', name: 'Cambodia' },
  { value: 'CMR', name: 'Cameroon' },
  { value: 'CAN', name: 'Canada' },
  { value: 'CAF', name: 'Central African Republic' },
  { value: 'TCD', name: 'Chad' },
  { value: 'CHL', name: 'Chile' },
  { value: 'CHN', name: 'China' },
  { value: 'COL', name: 'Colombia' },
  { value: 'COM', name: 'Comoros' },
  { value: 'COG', name: 'Congo' },
  { value: 'COD', name: 'Congo, the Democratic Republic of the' },
  { value: 'CRI', name: 'Costa Rica' },
  { value: 'CIV', name: 'Côte d’Ivoire' },
  { value: 'HRV', name: 'Croatia' },
  { value: 'CUB', name: 'Cuba' },
  { value: 'CYP', name: 'Cyprus' },
  { value: 'CZE', name: 'Czechia' },
  { value: 'DNK', name: 'Denmark' },
  { value: 'DJI', name: 'Djibouti' },
  { value: 'DMA', name: 'Dominica' },
  { value: 'DOM', name: 'Dominican Republic' },
  { value: 'ECU', name: 'Ecuador' },
  { value: 'EGY', name: 'Egypt' },
  { value: 'SLV', name: 'El Salvador' },
  { value: 'GNQ', name: 'Equatorial Guinea' },
  { value: 'ERI', name: 'Eritrea' },
  { value: 'EST', name: 'Estonia' },
  { value: 'SWZ', name: 'Eswatini' },
  { value: 'ETH', name: 'Ethiopia' },
  { value: 'FJI', name: 'Fiji' },
  { value: 'FIN', name: 'Finland' },
  { value: 'GAB', name: 'Gabon' },
  { value: 'GMB', name: 'Gambia' },
  { value: 'GEO', name: 'Georgia' },
  { value: 'DEU', name: 'Germany' },
  { value: 'GHA', name: 'Ghana' },
  { value: 'GRC', name: 'Greece' },
  { value: 'GRD', name: 'Grenada' },
  { value: 'GTM', name: 'Guatemala' },
  { value: 'GIN', name: 'Guinea' },
  { value: 'GNB', name: 'Guinea-Bissau' },
  { value: 'GUY', name: 'Guyana' },
  { value: 'HTI', name: 'Haiti' },
  { value: 'HND', name: 'Honduras' },
  { value: 'HUN', name: 'Hungary' },
  { value: 'ISL', name: 'Iceland' },
  { value: 'IND', name: 'India' },
  { value: 'IDN', name: 'Indonesia' },
  { value: 'IRN', name: 'Iran' },
  { value: 'IRQ', name: 'Iraq' },
  { value: 'IRL', name: 'Ireland' },
  { value: 'ISR', name: 'Israel' },
  { value: 'ITA', name: 'Italy' },
  { value: 'JAM', name: 'Jamaica' },
  { value: 'JPN', name: 'Japan' },
  { value: 'JOR', name: 'Jordan' },
  { value: 'KAZ', name: 'Kazakhstan' },
  { value: 'KEN', name: 'Kenya' },
  { value: 'KIR', name: 'Kiribati' },
  { value: 'PRK', name: "Korea, Democratic People's Republic of" },
  { value: 'KOR', name: 'Korea, Republic of' },
  { value: 'KWT', name: 'Kuwait' },
  { value: 'KGZ', name: 'Kyrgyzstan' },
  { value: 'LAO', name: "Lao People's Democratic Republic" },
  { value: 'LVA', name: 'Latvia' },
  { value: 'LBN', name: 'Lebanon' },
  { value: 'LSO', name: 'Lesotho' },
  { value: 'LBR', name: 'Liberia' },
  { value: 'LBY', name: 'Libya' },
  { value: 'LIE', name: 'Liechtenstein' },
  { value: 'LTU', name: 'Lithuania' },
  { value: 'LUX', name: 'Luxembourg' },
  { value: 'MDG', name: 'Madagascar' },
  { value: 'MWI', name: 'Malawi' },
  { value: 'MYS', name: 'Malaysia' },
  { value: 'MDV', name: 'Maldives' },
  { value: 'MLI', name: 'Mali' },
  { value: 'MLT', name: 'Malta' },
  { value: 'MHL', name: 'Marshall Islands' },
  { value: 'MRT', name: 'Mauritania' },
  { value: 'MUS', name: 'Mauritius' },
  { value: 'MEX', name: 'Mexico' },
  { value: 'FSM', name: 'Micronesia' },
  { value: 'MDA', name: 'Moldova' },
  { value: 'MCO', name: 'Monaco' },
  { value: 'MNG', name: 'Mongolia' },
  { value: 'MNE', name: 'Montenegro' },
  { value: 'MAR', name: 'Morocco' },
  { value: 'MOZ', name: 'Mozambique' },
  { value: 'MMR', name: 'Myanmar' },
  { value: 'NAM', name: 'Namibia' },
  { value: 'NRU', name: 'Nauru' },
  { value: 'NPL', name: 'Nepal' },
  { value: 'NZL', name: 'New Zealand' },
  { value: 'NIC', name: 'Nicaragua' },
  { value: 'NER', name: 'Niger' },
  { value: 'NGA', name: 'Nigeria' },
  { value: 'MKD', name: 'North Macedonia' },
  { value: 'NOR', name: 'Norway' },
  { value: 'OMN', name: 'Oman' },
  { value: 'PAK', name: 'Pakistan' },
  { value: 'PLW', name: 'Palau' },
  { value: 'PAN', name: 'Panama' },
  { value: 'PNG', name: 'Papua New Guinea' },
  { value: 'PRY', name: 'Paraguay' },
  { value: 'PER', name: 'Peru' },
  { value: 'PHL', name: 'Philippines' },
  { value: 'POL', name: 'Poland' },
  { value: 'PRT', name: 'Portugal' },
  { value: 'QAT', name: 'Qatar' },
  { value: 'ROU', name: 'Romania' },
  { value: 'RUS', name: 'Russian Federation' },
  { value: 'RWA', name: 'Rwanda' },
  { value: 'KNA', name: 'Saint Kitts and Nevis' },
  { value: 'LCA', name: 'Saint Lucia' },
  { value: 'VCT', name: 'Saint Vincent and the Grenadines' },
  { value: 'WSM', name: 'Samoa' },
  { value: 'SMR', name: 'San Marino' },
  { value: 'STP', name: 'Sao Tome and Principe' },
  { value: 'SAU', name: 'Saudi Arabia' },
  { value: 'SEN', name: 'Senegal' },
  { value: 'SRB', name: 'Serbia' },
  { value: 'SYC', name: 'Seychelles' },
  { value: 'SLE', name: 'Sierra Leone' },
  { value: 'SGP', name: 'Singapore' },
  { value: 'SVK', name: 'Slovakia' },
  { value: 'SVN', name: 'Slovenia' },
  { value: 'SLB', name: 'Solomon Islands' },
  { value: 'SOM', name: 'Somalia' },
  { value: 'ZAF', name: 'South Africa' },
  { value: 'SSD', name: 'South Sudan' },
  { value: 'ESP', name: 'Spain' },
  { value: 'LKA', name: 'Sri Lanka' },
  { value: 'SDN', name: 'Sudan' },
  { value: 'SUR', name: 'Suriname' },
  { value: 'SWE', name: 'Sweden' },
  { value: 'CHE', name: 'Switzerland' },
  { value: 'SYR', name: 'Syrian Arab Republic' },
  { value: 'TJK', name: 'Tajikistan' },
  { value: 'TZA', name: 'Tanzania' },
  { value: 'THA', name: 'Thailand' },
  { value: 'TLS', name: 'Timor-Leste' },
  { value: 'TGO', name: 'Togo' },
  { value: 'TON', name: 'Tonga' },
  { value: 'TTO', name: 'Trinidad and Tobago' },
  { value: 'TUN', name: 'Tunisia' },
  { value: 'TUR', name: 'Türkiye' },
  { value: 'TKM', name: 'Turkmenistan' },
  { value: 'TUV', name: 'Tuvalu' },
  { value: 'UGA', name: 'Uganda' },
  { value: 'UKR', name: 'Ukraine' },
  { value: 'ARE', name: 'United Arab Emirates' },
  { value: 'URY', name: 'Uruguay' },
  { value: 'UZB', name: 'Uzbekistan' },
  { value: 'VUT', name: 'Vanuatu' },
  { value: 'VAT', name: 'Vatican City' },
  { value: 'VEN', name: 'Venezuela' },
  { value: 'VNM', name: 'Vietnam' },
  { value: 'YEM', name: 'Yemen' },
  { value: 'ZMB', name: 'Zambia' },
  { value: 'ZWE', name: 'Zimbabwe' }
];
